// eslint-disable-next-line import/prefer-default-export
export const BatteryChargeEndpoint = {
  LOAD: '/viiu/battery-charge-level/load',
  SAVE: '/viiu/battery-charge-level/save',
  SAVE_ENABLED: '/viiu/battery-charge-level/save-enabled',
};
